export default __webpack_public_path__ + "static/gallery14-0c34f19ca1fb07409561741f4bf7b645.png";